import { useMemo, useRef, useState, forwardRef, useEffect } from 'react';
import { Image, Group, Rect } from 'react-konva';

function ColorBackground({ imageRef, image, color }) {
  const [position, setPosition] = useState({
    x: imageRef.current.x(),
    y: imageRef.current.y(),
  });
  const [size, setSize] = useState({
    width: imageRef.current.children[0].width() * imageRef.current.scaleX(),
    height: imageRef.current.children[0].height() * imageRef.current.scaleY(),
  });

  useEffect(() => {
    setPosition({
      x: imageRef.current.x(),
      y: imageRef.current.y(),
    });
    setSize({
      width: imageRef.current.children[0].width() * imageRef.current.scaleX(),
      height: imageRef.current.children[0].height() * imageRef.current.scaleY(),
    });
  }, [imageRef, image]);

  return (
    <>
      <Rect
        x={ position.x }
        y={ position.y }
        width={ size.width }
        height={ size.height }
        fill={ `rgb(${color.r},${color.g},${color.b})` }
      />
    </>
  );
}

export default ColorBackground;
